import React from 'react';
import {Link} from 'react-router-dom';
function Call2action() {
  return (
    <div>
      <div className="call2action">
        <div className="container">
          <div
            className="row justify-content-between align-items-center
                        sm:space-y-20">
            <div className="col-md-6">
              <div className="space-y-20">
                <h1 className="text-white">Create your own NFTease Page</h1>
                <p className="color_light section__text">
                NFTease is a platform to showcase your collections owned from
                Solana, Ethereum, Polygon and many other blockchains.
                
                </p>
                <Link
                  to="login"
                  className="btn
                                    btn-primary">
                  Get Started
                </Link>
              </div>
            </div>
            <div className="col-md-auto">
              <img
                className="img-fluid img__logo"
                alt="rr"
                src={`img/weedheads/illustration-x.png`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Call2action;
